var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 595.28005 595.28005",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 483.13,221.38 v 152.51 c 0,19.15 -10.3,37.01 -26.87,46.62 L 324.62,496.7 c -8.19,4.75 -17.52,7.25 -26.98,7.25 -9.46,0 -18.79,-2.5 -26.98,-7.25 L 139.02,420.51 C 122.44,410.9 112.14,393.04 112.14,373.89 V 221.38 c 0,-19.16 10.3,-37.02 26.88,-46.62 L 270.66,98.57 c 8.19,-4.75 17.52,-7.25 26.98,-7.25 9.46,0 18.79,2.5 26.98,7.25 l 131.64,76.19 c 16.57,9.6 26.87,27.46 26.87,46.62 z",
    style: {
      fill: "#f1f2f2"
    },
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.26,174.77 324.62,98.57 c -8.19,-4.74 -17.52,-7.25 -26.98,-7.25 -9.46,0 -18.79,2.51 -26.98,7.25 l -131.64,76.2 c -16.58,9.6 -26.88,27.46 -26.88,46.61 v 152.51 c 0,19.16 10.3,37.02 26.88,46.62 l 131.64,76.2 c 8.19,4.74 17.52,7.24 26.98,7.24 9.46,0 18.79,-2.5 26.98,-7.24 l 131.64,-76.2 c 16.57,-9.6 26.87,-27.46 26.87,-46.62 V 221.38 c 0,-19.15 -10.3,-37.01 -26.87,-46.61 z M 440.62,373.89 H 154.67 c -7.83,0 -14.17,-6.35 -14.17,-14.17 V 235.56 c 0,-7.83 6.35,-14.17 14.17,-14.17 h 285.95 c 7.83,0 14.17,6.35 14.17,14.17 v 124.16 c 0,7.83 -6.35,14.17 -14.17,14.17 z",
    style: {
      fill: "#bf7fb7",
      stroke: "#a05c9b",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 322.54,473.87 -15.64,9.03 c -5.73,3.31 -12.79,3.31 -18.52,0 l -15.64,-9.03 c -1.89,-1.09 -1.12,-3.98 1.07,-3.98 h 47.67 c 2.18,0 2.96,2.89 1.07,3.98 z",
    style: {
      fill: "#ffffff",
      stroke: "#a05c9b",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 272.74,121.4 15.64,-9.03 c 5.73,-3.31 12.79,-3.31 18.52,0 l 15.64,9.03 c 1.89,1.09 1.12,3.98 -1.07,3.98 H 273.8 c -2.18,0 -2.96,-2.89 -1.07,-3.98 z",
    style: {
      fill: "#ffffff",
      stroke: "#a05c9b",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    id: "path4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "matrix(2.7058182,0,0,2.7058182,230.10764,246.50628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 25.5,30.19 -2.57,-6.95 -6.95,-2.57 6.95,-2.57 2.57,-6.95 2.57,6.95 6.95,2.57 -6.95,2.57 z m -5.9,-9.52 4.31,1.59 1.59,4.31 1.59,-4.31 4.31,-1.59 -4.31,-1.59 -1.59,-4.31 -1.59,4.31 z",
    style: {
      fill: "#a86aad"
    },
    id: "path1-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.27,
    y: 11.68,
    width: 3.1700001,
    height: 1.26,
    transform: "rotate(-45,33.848721,12.309401)",
    style: {
      fill: "#a86aad"
    },
    id: "rect1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.73,14.9 c -0.39,0 -0.76,-0.15 -1.04,-0.43 -0.28,-0.28 -0.43,-0.64 -0.43,-1.04 0,-0.4 0.15,-0.76 0.43,-1.04 l 2.24,-2.24 c 0.57,-0.57 1.5,-0.57 2.07,0 0.28,0.28 0.43,0.64 0.43,1.04 0,0.4 -0.15,0.76 -0.43,1.04 l -2.24,2.24 c -0.28,0.28 -0.64,0.43 -1.04,0.43 z m 2.25,-3.92 c -0.05,0 -0.11,0.02 -0.15,0.06 l -2.24,2.24 c -0.05,0.05 -0.06,0.12 -0.06,0.15 0,0.03 0,0.09 0.06,0.15 0.11,0.11 0.19,0.11 0.3,0 l 2.24,-2.24 c 0.05,-0.05 0.06,-0.12 0.06,-0.15 0,-0.03 0,-0.09 -0.06,-0.15 C 35.09,11 35.04,10.98 34.98,10.98 Z",
    style: {
      fill: "#a86aad"
    },
    id: "path2-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.56,
    y: 28.389999,
    width: 3.1700001,
    height: 1.26,
    transform: "rotate(-45,17.140542,29.020155)",
    style: {
      fill: "#a86aad"
    },
    id: "rect2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.02,31.61 c -0.39,0 -0.76,-0.15 -1.04,-0.43 -0.57,-0.57 -0.57,-1.5 0,-2.07 l 2.24,-2.24 c 0.57,-0.57 1.5,-0.57 2.07,0 0.57,0.57 0.57,1.5 0,2.07 l -2.24,2.24 c -0.28,0.28 -0.64,0.43 -1.04,0.43 z m 2.25,-3.92 c -0.05,0 -0.11,0.02 -0.15,0.06 l -2.24,2.24 c -0.08,0.08 -0.08,0.21 0,0.3 0.11,0.11 0.19,0.11 0.3,0 l 2.24,-2.24 c 0.08,-0.08 0.08,-0.21 0,-0.3 -0.04,-0.04 -0.09,-0.06 -0.15,-0.06 z",
    style: {
      fill: "#a86aad"
    },
    id: "path3-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.52,
    y: 10.73,
    width: 1.26,
    height: 3.1700001,
    transform: "rotate(-45,17.14779,12.307153)",
    style: {
      fill: "#a86aad"
    },
    id: "rect3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.27,14.9 c -0.39,0 -0.76,-0.15 -1.04,-0.43 l -2.24,-2.24 c -0.57,-0.57 -0.57,-1.5 0,-2.07 0.57,-0.57 1.5,-0.57 2.07,0 l 2.24,2.24 c 0.57,0.57 0.57,1.5 0,2.07 -0.28,0.28 -0.64,0.43 -1.04,0.43 z m -2.25,-3.92 c -0.05,0 -0.11,0.02 -0.15,0.06 -0.08,0.08 -0.08,0.21 0,0.3 l 2.24,2.24 c 0.11,0.11 0.19,0.11 0.3,0 0.08,-0.08 0.08,-0.21 0,-0.3 l -2.24,-2.24 c 0,0 -0.09,-0.06 -0.15,-0.06 z",
    style: {
      fill: "#a86aad"
    },
    id: "path4-0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.23,
    y: 27.440001,
    width: 1.26,
    height: 3.1700001,
    transform: "rotate(-45.01,33.860949,29.017174)",
    style: {
      fill: "#a86aad"
    },
    id: "rect4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.98,31.61 c -0.39,0 -0.76,-0.15 -1.04,-0.43 L 31.7,28.94 c -0.28,-0.28 -0.43,-0.64 -0.43,-1.04 0,-0.4 0.15,-0.76 0.43,-1.04 0.57,-0.57 1.5,-0.57 2.07,0 l 2.24,2.24 c 0.57,0.57 0.57,1.5 0,2.07 -0.28,0.28 -0.64,0.43 -1.04,0.43 z m -2.25,-3.92 c -0.05,0 -0.11,0.02 -0.15,0.06 -0.08,0.08 -0.08,0.21 0,0.3 l 2.24,2.24 c 0.11,0.11 0.19,0.11 0.3,0 0.08,-0.08 0.08,-0.21 0,-0.3 l -2.24,-2.24 c 0,0 -0.09,-0.06 -0.15,-0.06 z",
    style: {
      fill: "#a86aad"
    },
    id: "path5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.42,18.58 25.5,12.96 27.58,18.58 33.21,20.67 27.58,22.75 25.5,28.38 23.42,22.75 17.79,20.67 ",
    style: {
      fill: "#34332b"
    },
    id: "polygon5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.360001,
    y: 20.040001,
    width: 3.1700001,
    height: 1.26,
    style: {
      fill: "#a86aad"
    },
    id: "rect5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.53,22.13 h -3.17 c -0.81,0 -1.47,-0.66 -1.47,-1.47 0,-0.81 0.66,-1.47 1.47,-1.47 h 3.17 c 0.81,0 1.47,0.66 1.47,1.47 0,0.81 -0.66,1.47 -1.47,1.47 z m -3.17,-1.67 c -0.12,0 -0.21,0.09 -0.21,0.21 0,0.12 0.09,0.21 0.21,0.21 h 3.17 c 0.12,0 0.21,-0.09 0.21,-0.21 0,-0.12 -0.09,-0.21 -0.21,-0.21 z",
    style: {
      fill: "#a86aad"
    },
    id: "path6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.47,
    y: 20.040001,
    width: 3.1700001,
    height: 1.26,
    style: {
      fill: "#a86aad"
    },
    id: "rect6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.64,22.13 H 10.47 C 9.66,22.13 9,21.47 9,20.66 9,19.85 9.66,19.19 10.47,19.19 h 3.17 c 0.81,0 1.47,0.66 1.47,1.47 0,0.81 -0.66,1.47 -1.47,1.47 z m -3.17,-1.67 c -0.12,0 -0.21,0.09 -0.21,0.21 0,0.12 0.09,0.21 0.21,0.21 h 3.17 c 0.12,0 0.21,-0.09 0.21,-0.21 0,-0.12 -0.09,-0.21 -0.21,-0.21 z",
    style: {
      fill: "#a86aad"
    },
    id: "path7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.360001,
    y1: 20.67,
    x2: 40.529999,
    y2: 20.67,
    style: {
      fill: "#34332b"
    },
    id: "line7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.53,21.5 h -3.17 c -0.46,0 -0.84,-0.37 -0.84,-0.84 0,-0.47 0.37,-0.84 0.84,-0.84 h 3.17 c 0.46,0 0.84,0.38 0.84,0.84 0,0.46 -0.37,0.84 -0.84,0.84 z",
    style: {
      fill: "#34332b"
    },
    id: "path8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.47,
    y1: 20.67,
    x2: 13.64,
    y2: 20.67,
    style: {
      fill: "#34332b"
    },
    id: "line8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.64,21.5 h -3.17 c -0.46,0 -0.84,-0.37 -0.84,-0.84 0,-0.47 0.37,-0.84 0.84,-0.84 h 3.17 c 0.46,0 0.84,0.38 0.84,0.84 0,0.46 -0.37,0.84 -0.84,0.84 z",
    style: {
      fill: "#34332b"
    },
    id: "path9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.870001,
    y: 32.529999,
    width: 1.26,
    height: 3.1700001,
    style: {
      fill: "#a86aad"
    },
    id: "rect9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.03,35.7 v -3.17 c 0,-0.81 0.66,-1.47 1.47,-1.47 0.81,0 1.47,0.66 1.47,1.47 v 3.17 c 0,0.81 -0.66,1.47 -1.47,1.47 -0.81,0 -1.47,-0.66 -1.47,-1.47 z m 1.68,-3.17 c 0,-0.12 -0.09,-0.21 -0.21,-0.21 -0.12,0 -0.21,0.09 -0.21,0.21 v 3.17 c 0,0.12 0.09,0.21 0.21,0.21 0.12,0 0.21,-0.09 0.21,-0.21 z",
    style: {
      fill: "#a86aad"
    },
    id: "path10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.870001,
    y: 5.6300001,
    width: 1.26,
    height: 3.1700001,
    style: {
      fill: "#a86aad"
    },
    id: "rect10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.03,8.81 V 5.64 c 0,-0.81 0.66,-1.47 1.47,-1.47 0.81,0 1.47,0.66 1.47,1.47 v 3.17 c 0,0.81 -0.66,1.47 -1.47,1.47 -0.81,0 -1.47,-0.66 -1.47,-1.47 z m 1.68,-3.18 c 0,-0.12 -0.09,-0.21 -0.21,-0.21 -0.12,0 -0.21,0.09 -0.21,0.21 V 8.8 c 0,0.12 0.09,0.21 0.21,0.21 0.12,0 0.21,-0.09 0.21,-0.21 z",
    style: {
      fill: "#a86aad"
    },
    id: "path11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 32.529999,
    x2: 25.5,
    y2: 35.700001,
    style: {
      fill: "#34332b"
    },
    id: "line11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.66,35.7 v -3.17 c 0,-0.46 0.37,-0.84 0.84,-0.84 0.47,0 0.84,0.37 0.84,0.84 v 3.17 c 0,0.46 -0.38,0.84 -0.84,0.84 -0.46,0 -0.84,-0.37 -0.84,-0.84 z",
    style: {
      fill: "#34332b"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 5.6300001,
    x2: 25.5,
    y2: 8.8100004,
    style: {
      fill: "#34332b"
    },
    id: "line12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.66,8.81 V 5.64 c 0,-0.46 0.37,-0.84 0.84,-0.84 0.47,0 0.84,0.37 0.84,0.84 v 3.17 c 0,0.46 -0.38,0.84 -0.84,0.84 -0.46,0 -0.84,-0.37 -0.84,-0.84 z",
    style: {
      fill: "#34332b"
    },
    id: "path13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.73,
    y1: 13.43,
    x2: 34.98,
    y2: 11.19,
    style: {
      fill: "#34332b"
    },
    id: "line13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.73,14.27 c -0.21,0 -0.43,-0.08 -0.59,-0.25 -0.33,-0.33 -0.33,-0.86 0,-1.18 l 2.24,-2.24 c 0.33,-0.33 0.86,-0.33 1.18,0 0.32,0.33 0.33,0.86 0,1.18 l -2.24,2.24 c -0.16,0.16 -0.38,0.25 -0.59,0.25 z",
    style: {
      fill: "#34332b"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.02,
    y1: 30.139999,
    x2: 18.27,
    y2: 27.9,
    style: {
      fill: "#34332b"
    },
    id: "line14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.02,30.98 c -0.21,0 -0.43,-0.08 -0.59,-0.25 -0.33,-0.33 -0.33,-0.86 0,-1.18 l 2.24,-2.24 c 0.33,-0.33 0.86,-0.33 1.18,0 0.32,0.33 0.33,0.86 0,1.18 l -2.24,2.24 c -0.16,0.16 -0.38,0.25 -0.59,0.25 z",
    style: {
      fill: "#34332b"
    },
    id: "path15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.27,
    y1: 13.43,
    x2: 16.02,
    y2: 11.19,
    style: {
      fill: "#34332b"
    },
    id: "line15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.27,14.27 c -0.21,0 -0.43,-0.08 -0.59,-0.25 l -2.24,-2.24 c -0.33,-0.33 -0.33,-0.86 0,-1.18 0.33,-0.32 0.86,-0.33 1.18,0 l 2.24,2.24 c 0.33,0.33 0.33,0.86 0,1.18 -0.16,0.16 -0.38,0.25 -0.59,0.25 z",
    style: {
      fill: "#34332b"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.98,
    y1: 30.139999,
    x2: 32.73,
    y2: 27.9,
    style: {
      fill: "#34332b"
    },
    id: "line16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.98,30.98 c -0.21,0 -0.43,-0.08 -0.59,-0.25 l -2.24,-2.24 c -0.33,-0.33 -0.33,-0.86 0,-1.18 0.33,-0.32 0.86,-0.33 1.18,0 l 2.24,2.24 c 0.33,0.33 0.33,0.86 0,1.18 -0.16,0.16 -0.38,0.25 -0.59,0.25 z",
    style: {
      fill: "#34332b"
    },
    id: "path17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLook);
export default __webpack_public_path__ + "static/media/look.34e1c3bc120a7cfdc9763b5f21b9db5f.svg";
export { ForwardRef as ReactComponent };